import * as XLSX from 'xlsx-js-style'
import moment from 'moment'
import 'moment/locale/id'

const TABLE_COLUMNS = ['Waktu', 'No bukti', 'Keterangan', 'Nominal', 'Diinput']
const COL_COUNT = TABLE_COLUMNS.length

const BORDER = {
  top: { style: 'thin', color: { rgb: 'FF999999' } },
  bottom: { style: 'thin', color: { rgb: 'FF999999' } },
  left: { style: 'thin', color: { rgb: 'FF999999' } },
  right: { style: 'thin', color: { rgb: 'FF999999' } }
}

function toNumber (value) {
  const num = Number(value)
  return Number.isFinite(num) ? num : 0
}

function formatDisplayDatetime (value) {
  if (!value) return ''
  moment.locale('id')
  return moment(value).format('DD MMM YYYY HH:mm')
}

function formatRupiah (value) {
  const num = toNumber(value)
  const negative = num < 0
  const abs = Math.abs(Math.round(num))
  const reverse = String(abs).split('').reverse().join('')
  let grouped = ''

  for (let i = 0; i < reverse.length; i++) {
    if (i > 0 && i % 3 === 0) grouped += '.'
    grouped += reverse[i]
  }

  const amount = grouped.split('').reverse().join('')
  return `${negative ? '- ' : ''}Rp ${amount}`
}

function buildInfoRows ({ projectName, categoryTitle, balance }) {
  const rows = [['Nama Project', projectName || '']]
  if (categoryTitle) rows.push(['Kategori', categoryTitle])
  rows.push(['Saldo', formatRupiah(balance)])
  return rows
}

function expandSheetRange (worksheet, row, col) {
  const ref = XLSX.utils.encode_cell({ r: row, c: col })

  if (!worksheet['!ref']) {
    worksheet['!ref'] = `${ref}:${ref}`
    return ref
  }

  const range = XLSX.utils.decode_range(worksheet['!ref'])
  if (row < range.s.r) range.s.r = row
  if (col < range.s.c) range.s.c = col
  if (row > range.e.r) range.e.r = row
  if (col > range.e.c) range.e.c = col
  worksheet['!ref'] = XLSX.utils.encode_range(range)

  return ref
}

function ensureCell (worksheet, row, col, value = '') {
  const ref = expandSheetRange(worksheet, row, col)

  if (!worksheet[ref]) {
    worksheet[ref] = { t: 's', v: value }
  }

  return worksheet[ref]
}

function setBorder (worksheet, row, col) {
  const cell = ensureCell(worksheet, row, col)
  cell.s = { ...(cell.s || {}), border: BORDER }
}

function applyRangeBorders (worksheet, startRow, endRow, startCol, endCol) {
  for (let r = startRow; r <= endRow; r++) {
    for (let c = startCol; c <= endCol; c++) {
      setBorder(worksheet, r, c)
    }
  }
}

function applyTableBorders (worksheet, startRow, endRow) {
  applyRangeBorders(worksheet, startRow, endRow, 0, COL_COUNT - 1)
}

export function buildProjectRealisasiWorkbook ({
  items = [],
  projectName = '',
  categoryTitle = '',
  balance = 0,
  exportedAt = new Date()
}) {
  const exportLabel = moment(exportedAt).format('DD MMM YYYY HH:mm:ss')
  const infoRows = buildInfoRows({ projectName, categoryTitle, balance })
  const headerRowIndex = 3 + infoRows.length + 1
  const dataStartIndex = headerRowIndex + 1

  const dataRows = items.map(item => [
    formatDisplayDatetime(item.input_datetime),
    item.ledger_number || '',
    item.note || '',
    formatRupiah(item.value),
    item.input_admin_name || ''
  ])

  const sheetData = [
    ['Data Realisasi'],
    [`Waktu Export: ${exportLabel}`],
    [],
    ...infoRows,
    [],
    TABLE_COLUMNS,
    ...dataRows
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData)

  worksheet['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COL_COUNT - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: COL_COUNT - 1 } }
  ]

  worksheet['!cols'] = [
    { wch: 22 },
    { wch: 28 },
    { wch: 44 },
    { wch: 20 },
    { wch: 24 }
  ]

  const infoStartRow = 3
  const infoEndRow = infoStartRow + infoRows.length - 1

  applyRangeBorders(worksheet, 1, 1, 0, COL_COUNT - 1)
  applyRangeBorders(worksheet, infoStartRow, infoEndRow, 0, 1)

  const tableEndRow = items.length > 0 ? dataStartIndex + items.length - 1 : headerRowIndex
  applyTableBorders(worksheet, headerRowIndex, tableEndRow)

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data Realisasi')

  return workbook
}

export function downloadProjectRealisasiExcel (options) {
  const workbook = buildProjectRealisasiWorkbook(options)
  const filename = `REALISASI-${moment(options.exportedAt || new Date()).format('YYYY-MM-DD-HHmmss')}.xlsx`
  XLSX.writeFile(workbook, filename, { cellStyles: true })
  return filename
}
